import axios from "axios";
import { fpoWarehousesUrl, fpoWarehouseDetailUrl } from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /procurement/warehouses/ — list all warehouses for the caller's FPO
 */
export const getWarehouses = async (params = {}) => {
    const response = await axios.get(fpoWarehousesUrl, { ...authHeaders(), params });
    return response;
};

/**
 * POST /procurement/warehouses/ — add a new warehouse (fpo_admin only)
 */
export const addWarehouse = async (data) => {
    const response = await axios.post(fpoWarehousesUrl, data, authHeaders());
    return response;
};

/**
 * PATCH /procurement/warehouses/<id>/ — edit a warehouse (fpo_admin only)
 */
export const updateWarehouse = async (id, data) => {
    const response = await axios.patch(fpoWarehouseDetailUrl(id), data, authHeaders());
    return response;
};

/**
 * DELETE /procurement/warehouses/<id>/ — delete a warehouse (fpo_admin only)
 */
export const deleteWarehouse = async (id) => {
    const response = await axios.delete(fpoWarehouseDetailUrl(id), authHeaders());
    return response;
};
